var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-align-center"},[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v(" Looks like you are lost. You should head back "),_c('router-link',{attrs:{"to":"/","color":"info"}},[_vm._v("Home")]),_vm._v(". ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }